
  export default {
    props: {
      rules: {
        type: Array,
        default: () => []
      },
      label: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: ''
      },
      date: {
        type: String,
        default: ''
      },
      time: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      },
      allowTime: {
        type: Boolean,
        default: true
      },
      outlined: {
        type: Boolean,
        default: true
      },
      filled: {
        type: Boolean,
        default: false
      },
      maxDate: {
        type: String,
        default: ''
      },
      minDate: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        dialog: false,
        tabs: null,
        slDate: null,
        selectedDate: '',
        selectedTime: this.time
      }
    },
    watch: {
      date(v) {
        this.slDate = this.$dayjs(v).format(this.allowTime ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD ')
        if (v) {
          this.selectedDate = this.$dayjs(v).format('YYYY-MM-DD')
        }
      }
    },
    mounted() {
      if (this.date) {
        this.selectedDate = this.$dayjs(this.date).format('YYYY-MM-DD')
        this.slDate = this.$dayjs(this.date).format(
          this.allowTime ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD '
        )
      }
    },
    methods: {
      save(value) {
        this.$refs.dialogDateAndTime.save(value)
        if (this.selectedDate) {
          this.selectedDate = `${this.$dayjs(this.selectedDate).format('YYYY-MM-DD')} ${
            this.selectedTime ? this.selectedTime : this.time
          }`
          this.slDate = this.$dayjs(this.selectedDate).format(
            this.allowTime ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD'
          )
          this.$emit('update', `${this.selectedDate}`)
        }
      }
    }
  }
